import { createFileRoute } from '@tanstack/react-router'
import { BuyerTargetsPage } from '@/features/buyer-panel/pages/buyer-targets-page'

export const Route = createFileRoute('/_authenticated/buyer-panel/targets')({
  component: BuyerTargetsPage,
})
